export const useColon = (str: string, asill?: boolean) => {
    const i18n = useI18n();
    if (i18n.locale.value === "en") {
        return str + ":" + (asill ? "&nbsp;" : " ");
    } else {
        return str + "：";
    }
};
